export default "__VITE_ASSET__BKy6$SDS__"